<template>
  <div class="account-mobile-header">
    <button type="button" class="mobile-back-btn" :aria-label="returnLabel" @click="$emit('close')">
      <el-icon aria-hidden="true"><ArrowLeft /></el-icon>
    </button>
    <span class="mobile-header-title">{{ title }}</span>
  </div>
</template>

<script>
import { ArrowLeft } from '@element-plus/icons-vue'

export default {
  name: 'MobileAccountHeader',
  components: { ArrowLeft },
  props: {
    returnLabel: { type: String, required: true },
    title: { type: String, required: true }
  },
  emits: ['close']
}
</script>
